function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgParticles2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1920,
    height: 595,
    preserveAspectRatio: "xMidYMid",
    viewBox: "0 0 1920 595",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("defs", {
    style: {
      animationPlayState: "paused"
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-d9ob1pqwabe-1",
    d: "M-35 -35L35 -35L35 35L-35 35Z",
    fill: "none",
    stroke: "inherit",
    strokeWidth: 4.333333333333334,
    transform: "scale(0.3)",
    style: {
      transform: "matrix(0.3, 0, 0, 0.3, 0, 0)",
      animationPlayState: "paused"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-d9ob1pqwabe-2",
    d: "M0 -37A37 37 0 0 1 0 37A37 37 0 0 1 0 -37",
    fill: "none",
    stroke: "inherit",
    strokeWidth: 4.333333333333334,
    transform: "scale(0.3)",
    style: {
      transform: "matrix(0.3, 0, 0, 0.3, 0, 0)",
      animationPlayState: "paused"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-d9ob1pqwabe-3",
    d: "M0 -34.641L40 34.641L-40 34.641Z",
    fill: "none",
    stroke: "inherit",
    strokeWidth: 4.333333333333334,
    transform: "scale(0.3)",
    style: {
      transform: "matrix(0.3, 0, 0, 0.3, 0, 0)",
      animationPlayState: "paused"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "path0",
    d: "M 117.23790890030754 300.1854302560581 c 0 50.72953654031676 -12.412546174758354 14.571249857325027 -26.98379603208338 14.571249857325027 S 63.27031683614079 350.91496679637487 63.27031683614079 300.1854302560581 s 12.412546174758354 -14.571249857325027 26.98379603208338 -14.571249857325027 S 117.23790890030754 249.45589371574135 117.23790890030754 300.1854302560581 z",
    fill: "none",
    stroke: "none",
    style: {
      animationPlayState: "paused"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-d9ob1pqwabe-3",
    x: 0,
    y: 0,
    stroke: "#95d5ee",
    transform: "translate(116.94658660888672 311.81219482421875)",
    style: {
      animationPlayState: "paused"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1",
    d: "M 167.0211106092329 176.90766669846147 c 0 29.29263026136014 -7.167345702247693 8.413840606986424 -15.581186309234116 8.413840606986424 S 135.85873799076467 206.2002969598216 135.85873799076467 176.90766669846147 s 7.167345702247693 -8.413840606986424 15.581186309234116 -8.413840606986424 S 167.0211106092329 147.61503643710134 167.0211106092329 176.90766669846147 z",
    fill: "none",
    stroke: "none",
    style: {
      animationPlayState: "paused"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-d9ob1pqwabe-2",
    x: 0,
    y: 0,
    stroke: "#ffe691",
    transform: "translate(167.01622009277344 178.18707275390625)",
    style: {
      animationPlayState: "paused"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2",
    d: "M 286.6261012287174 347.7637773052078 c 0 53.56943788369491 -13.107415652393435 15.386966200635772 -28.494381853029207 15.386966200635772 S 229.63733752265898 401.33321518890267 229.63733752265898 347.7637773052078 s 13.107415652393435 -15.386966200635772 28.494381853029207 -15.386966200635772 S 286.6261012287174 294.1943394215129 286.6261012287174 347.7637773052078 z",
    fill: "none",
    stroke: "none",
    style: {
      animationPlayState: "paused"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-d9ob1pqwabe-1",
    x: 0,
    y: 0,
    stroke: "#95d5ee",
    transform: "translate(260.64166259765625 363.4740295410156)",
    style: {
      animationPlayState: "paused"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3",
    d: "M 361.71810222934846 317.2068323440975 c 0 26.18935967956145 -6.408034815211843 7.52247565263999 -13.930510467851834 7.52247565263999 S 333.8570812936448 343.39619202365895 333.8570812936448 317.2068323440975 s 6.408034815211843 -7.52247565263999 13.930510467851834 -7.52247565263999 S 361.71810222934846 291.01747266453606 361.71810222934846 317.2068323440975 z",
    fill: "none",
    stroke: "none",
    style: {
      animationPlayState: "paused"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-d9ob1pqwabe-1",
    x: 0,
    y: 0,
    stroke: "#95d5ee",
    transform: "translate(343.3712158203125 326.5181884765625)",
    style: {
      animationPlayState: "paused"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4",
    d: "M 469.62505240138915 27.469399499128595 c 0 47.95106707170515 -11.732707900523598 13.773178839745094 -25.505886740268693 13.773178839745094 S 418.61327892085177 75.42046657083374 418.61327892085177 27.469399499128595 s 11.732707900523598 -13.773178839745094 25.505886740268693 -13.773178839745094 S 469.62505240138915 -20.48166757257655 469.62505240138915 27.469399499128595 z",
    fill: "none",
    stroke: "none",
    style: {
      animationPlayState: "paused"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-d9ob1pqwabe-2",
    x: 0,
    y: 0,
    stroke: "#ffb6bb",
    transform: "translate(455.93084716796875 47.52762985229492)",
    style: {
      animationPlayState: "paused"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5",
    d: "M 631.9758874591596 103.58655286557419 c 0 19.001025620097693 -4.649187119811137 5.457741401517422 -10.106928521328559 5.457741401517422 S 611.7620304165025 122.58757848567188 611.7620304165025 103.58655286557419 s 4.649187119811137 -5.457741401517422 10.106928521328559 -5.457741401517422 S 631.9758874591596 84.5855272454765 631.9758874591596 103.58655286557419 z",
    fill: "none",
    stroke: "none",
    style: {
      animationPlayState: "paused"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-d9ob1pqwabe-2",
    x: 0,
    y: 0,
    stroke: "#ffe691",
    transform: "translate(631.7719116210938 109.20510864257812)",
    style: {
      animationPlayState: "paused"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path6",
    d: "M 685.9253900815977 129.32574724594582 c 0 63.386487711419456 -15.5094597591771 18.206757108599206 -33.7162168677763 18.206757108599206 S 618.492956346045 192.71223495736527 618.492956346045 129.32574724594582 s 15.5094597591771 -18.206757108599206 33.7162168677763 -18.206757108599206 S 685.9253900815977 65.93925953452637 685.9253900815977 129.32574724594582 z",
    fill: "none",
    stroke: "none",
    style: {
      animationPlayState: "paused"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-d9ob1pqwabe-1",
    x: 0,
    y: 0,
    stroke: "#ffe691",
    transform: "translate(680.8280639648438 162.53890991210938)",
    style: {
      animationPlayState: "paused"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path7",
    d: "M 786.0444305319057 312.22252645919036 c 0 25.06346039739249 -6.132548820638587 7.199079050314864 -13.33162787095345 7.199079050314864 S 759.3811747899989 337.28598685658284 759.3811747899989 312.22252645919036 s 6.132548820638587 -7.199079050314864 13.33162787095345 -7.199079050314864 S 786.0444305319057 287.1590660617979 786.0444305319057 312.22252645919036 z",
    fill: "none",
    stroke: "none",
    style: {
      animationPlayState: "paused"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-d9ob1pqwabe-1",
    x: 0,
    y: 0,
    stroke: "#ffe691",
    transform: "translate(772.7734375 319.42218017578125)",
    style: {
      animationPlayState: "paused"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path8",
    d: "M 953.002460357686 347.40217282743583 c 0 54.9735980143171 -13.45098674818397 15.790288791346402 -29.24127553953037 15.790288791346402 S 894.5199092786252 402.3757708417529 894.5199092786252 347.40217282743583 s 13.45098674818397 -15.790288791346402 29.24127553953037 -15.790288791346402 S 953.002460357686 292.42857481311876 953.002460357686 347.40217282743583 z",
    fill: "none",
    stroke: "none",
    style: {
      animationPlayState: "paused"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-d9ob1pqwabe-2",
    x: 0,
    y: 0,
    stroke: "#95d5ee",
    transform: "translate(906.451171875 373.6270446777344)",
    style: {
      animationPlayState: "paused"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path9",
    d: "M 995.2787318864364 342.7306918876337 c 0 46.14377140484517 -11.290497258632326 13.254061999264037 -24.544559257896363 13.254061999264037 S 946.1896133706437 388.8744632924789 946.1896133706437 342.7306918876337 s 11.290497258632326 -13.254061999264037 24.544559257896363 -13.254061999264037 S 995.2787318864364 296.58692048278857 995.2787318864364 342.7306918876337 z",
    fill: "none",
    stroke: "none",
    style: {
      animationPlayState: "paused"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-d9ob1pqwabe-3",
    x: 0,
    y: 0,
    stroke: "#95d5ee",
    transform: "translate(989.9530029296875 367.3365173339844)",
    style: {
      animationPlayState: "paused"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path10",
    d: "M 1162.0317903146674 177.6053539507705 c 0 29.26304888142481 -7.160107705029475 8.405343827643296 -15.565451532672771 8.405343827643296 S 1130.9008872493218 206.86840283219533 1130.9008872493218 177.6053539507705 s 7.160107705029475 -8.405343827643296 15.565451532672771 -8.405343827643296 S 1162.0317903146674 148.34230506934568 1162.0317903146674 177.6053539507705 z",
    fill: "none",
    stroke: "none",
    style: {
      animationPlayState: "paused"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-d9ob1pqwabe-1",
    x: 0,
    y: 0,
    stroke: "#ffb6bb",
    transform: "translate(1141.5213623046875 188.0172119140625)",
    style: {
      animationPlayState: "paused"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path11",
    d: "M 1243.5703545313845 450.58249737678426 c 0 27.250102372682075 -6.667578240124337 7.827157064493788 -14.494735304618125 7.827157064493788 S 1214.5808839221481 477.83259974946634 1214.5808839221481 450.58249737678426 s 6.667578240124337 -7.827157064493788 14.494735304618125 -7.827157064493788 S 1243.5703545313845 423.3323950041022 1243.5703545313845 450.58249737678426 z",
    fill: "none",
    stroke: "none",
    style: {
      animationPlayState: "paused"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-d9ob1pqwabe-2",
    x: 0,
    y: 0,
    stroke: "#ffb6bb",
    transform: "translate(1235.123779296875 461.4158935546875)",
    style: {
      animationPlayState: "paused"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path12",
    d: "M 1388.7579543096654 338.2589877294768 c 0 29.85145721647825 -7.304079957223401 8.574354732392688 -15.878434689616089 8.574354732392688 S 1357.001084930433 368.11044494595507 1357.001084930433 338.2589877294768 s 7.304079957223401 -8.574354732392688 15.878434689616089 -8.574354732392688 S 1388.7579543096654 308.40753051299856 1388.7579543096654 338.2589877294768 z",
    fill: "none",
    stroke: "none",
    style: {
      animationPlayState: "paused"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-d9ob1pqwabe-2",
    x: 0,
    y: 0,
    stroke: "#ffb6bb",
    transform: "translate(1385.783203125 354.150146484375)",
    style: {
      animationPlayState: "paused"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path13",
    d: "M 1409.204644018955 253.28401782820038 c 0 55.20440422861825 -13.507460609129996 15.85658419332652 -29.36404480245652 15.85658419332652 S 1350.476554414042 308.48842205681865 1350.476554414042 253.28401782820038 s 13.507460609129996 -15.85658419332652 29.36404480245652 -15.85658419332652 S 1409.204644018955 198.07961359958213 1409.204644018955 253.28401782820038 z",
    fill: "none",
    stroke: "none",
    style: {
      animationPlayState: "paused"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-d9ob1pqwabe-1",
    x: 0,
    y: 0,
    stroke: "#95d5ee",
    transform: "translate(1409.196044921875 255.59347534179688)",
    style: {
      animationPlayState: "paused"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path14",
    d: "M 1515.7329518739743 70.79188150026789 c 0 24.095127805900628 -5.895616378039515 6.9209409655246485 -12.816557343564163 6.9209409655246485 S 1490.099837186846 94.88700930616852 1490.099837186846 70.79188150026789 s 5.895616378039515 -6.9209409655246485 12.816557343564163 -6.9209409655246485 S 1515.7329518739743 46.69675369436726 1515.7329518739743 70.79188150026789 z",
    fill: "none",
    stroke: "none",
    style: {
      animationPlayState: "paused"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-d9ob1pqwabe-1",
    x: 0,
    y: 0,
    stroke: "#ffe691",
    transform: "translate(1515.7222900390625 72.40332794189453)",
    style: {
      animationPlayState: "paused"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path15",
    d: "M 1644.575481316604 146.29360049081572 c 0 52.66407618601423 -12.88589098168433 15.126915500238129 -28.01280648192246 15.126915500238129 S 1588.549868352759 198.95767667682995 1588.549868352759 146.29360049081572 s 12.88589098168433 -15.126915500238129 28.01280648192246 -15.126915500238129 S 1644.575481316604 93.62952430480149 1644.575481316604 146.29360049081572 z",
    fill: "none",
    stroke: "none",
    style: {
      animationPlayState: "paused"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-d9ob1pqwabe-3",
    x: 0,
    y: 0,
    stroke: "#95d5ee",
    transform: "translate(1605.148681640625 167.00006103515625)",
    style: {
      animationPlayState: "paused"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path16",
    d: "M 1762.4241295211136 259.38311958369445 c 0 32.90434228024217 -8.051062472825212 9.451247250707858 -17.50230972353307 9.451247250707858 S 1727.4195100740476 292.28746186393664 1727.4195100740476 259.38311958369445 s 8.051062472825212 -9.451247250707858 17.50230972353307 -9.451247250707858 S 1762.4241295211136 226.4787773034523 1762.4241295211136 259.38311958369445 z",
    fill: "none",
    stroke: "none",
    style: {
      animationPlayState: "paused"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-d9ob1pqwabe-2",
    x: 0,
    y: 0,
    stroke: "#ffe691",
    transform: "translate(1761.61328125 272.5021667480469)",
    style: {
      animationPlayState: "paused"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path17",
    d: "M 1878.4947795931935 81.58287909775241 c 0 34.23348335362835 -8.376277841845233 9.833021814340059 -18.20929965618529 9.833021814340059 S 1842.0761802808229 115.81636245138077 1842.0761802808229 81.58287909775241 s 8.376277841845233 -9.833021814340059 18.20929965618529 -9.833021814340059 S 1878.4947795931935 47.34939574412406 1878.4947795931935 81.58287909775241 z",
    fill: "none",
    stroke: "none",
    style: {
      animationPlayState: "paused"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-d9ob1pqwabe-1",
    x: 0,
    y: 0,
    stroke: "#ffe691",
    transform: "translate(1855.000732421875 93.41001892089844)",
    style: {
      animationPlayState: "paused"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParticles2);
export default __webpack_public_path__ + "static/media/particles-2.9e39a52bf544170be244cb6d2ccba30e.svg";
export { ForwardRef as ReactComponent };